import { CKBox, CKSwitch } from '@clearkit/react';

import SearchBuilder from '~/components/SearchBuilder';

export const ConfigureROIMetricsStep = ({
  id,
  enabled,
  onToggle,
  attributes,
  search,
  onSearchChange,
}) => {
  return (
    <CKBox>
      <div className="p-4">
        <CKSwitch id={id} onChange={onToggle} checked={enabled}>
          Enable this step in the funnel
        </CKSwitch>
      </div>
      {enabled && (
        <div className="p-4 border-t border-gray-200">
          <SearchBuilder
            type="Person"
            search={search}
            onChange={onSearchChange}
            attributes={attributes}
          />
        </div>
      )}
    </CKBox>
  );
};

export default ConfigureROIMetricsStep;
